import { ActionModeType } from 'src/app/model';

export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum ButtonLabelPosition {
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
}

export enum ButtonOption {
  ICON = 'icon',
  BASIC = 'basic',
}

export enum ButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TRANSPARENT = 'transparent',
}

export enum ButtonIconColor {
  ACTUAL = 'actual',
  DEFAULT = 'default',
}

export enum ButtonSize {
  DEFAULT = 'default',
  SMALL = 'small',
  CIRCLE = 'circle',
}

export interface ButtonModel {
  label: string;
  labelPosition?: ButtonLabelPositionType;
  disabled?: boolean;
  type?: FormButtonType;
  icon?: string;
  hoverIcon?: string;
  iconSize?: number;
  option?: ButtonOptionType;
  color?: ButtonColorType;
  iconColor?: ButtonIconColorType;
  action?: ActionModeType;
  value?: boolean;
  size?: ButtonSizeType;
  tooltip?: string;
}

export interface ButtonActionModel<T> {
  data: T;
  action: ActionModeType;
}

export type FormButtonType =
  | ButtonType.BUTTON
  | ButtonType.SUBMIT
  | ButtonType.RESET;

export type ButtonLabelPositionType =
  | ButtonLabelPosition.PREFIX
  | ButtonLabelPosition.SUFFIX;

export type ButtonOptionType = ButtonOption.BASIC | ButtonOption.ICON;

export type ButtonColorType =
  | ButtonColor.PRIMARY
  | ButtonColor.SECONDARY
  | ButtonColor.TRANSPARENT;

export type ButtonIconColorType =
  | ButtonIconColor.ACTUAL
  | ButtonIconColor.DEFAULT;

export type ButtonSizeType =
  | ButtonSize.SMALL
  | ButtonSize.DEFAULT
  | ButtonSize.CIRCLE;
